import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  iconButton: {
    boxShadow: "none",
    padding: spacing(1),
  },
  iconList: {
    minWidth: "24px",
  },
  paper: {
    width: "100%",
    maxWidth: "250px",
  },
  badgeColor: {
    backgroundColor: palette.warning.main,
  },
  textWithIcon: {
    maxWidth: "fit-content",
    marginRight: spacing(1),
  },
}));
